import { ChooseProductPage } from 'modules/choose-product';
import { withModalBox } from '@nakedplatform/ui';

export default withModalBox(ChooseProductPage);
